import { useContext } from "react";
import { PropContext } from "../layout/PropContext";
import { ListGroup } from "react-bootstrap";
import { getAssetTitle } from "../util/api";
import ListSidebar from "./ListSidebar";

//Renders a sidebar with multiple categories when the page has more than one list.
export default function MultipleListsSidebar() {
  const { assets } = useContext(PropContext);

  return (
    <ListGroup className="sidebar">
      {Object.entries(assets).map(([key, value]) => {
        if (key === "sidebar" || key === "origin") return null;
        return (
          <ListGroup.Item className="sidebar-background" key={key}>
            <h4>{getAssetTitle(key)}</h4>
            <ListGroup style={{ padding: 0 }}>
              <ListSidebar
                list={{
                  [key]: value,
                  sidebar: { src: key },
                }}
              />
            </ListGroup>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
}
